import { Card, Col, Row, Table } from 'react-bootstrap'
import PageHeader from '../../layouts/PageHeader/PageHeader'
import { useGetQuestionByIdQuery } from '../../store/api/question/question.api'
import { Params, useParams } from 'react-router-dom'
import Loading from '../Loading/Loading'

const QuestionChoice = (): JSX.Element => {
  const { id }: Readonly<Params<string>> = useParams()
  const { data: choice, isLoading } = useGetQuestionByIdQuery(String(id))

  return (
    <div>
      {isLoading && <Loading />}
      <div className='d-flex justify-content-between h-10'>
        <div className=' p-2'>
          <PageHeader
            componentName='Question Choice'
            staticName='Question Choice'
            activePage=''
            createPageUrl={''}
          />
        </div>
      </div>
      <Row className=' row-sm'>
        <Col lg={12}>
          <Card className='custom-card'>
            <Card.Header>
              <div>
                <h3 className='card-title mb-1'>Question Choice</h3>
              </div>
            </Card.Header>
            <Card.Body>
              <div className='table-responsive'>
                <Table className='table table-bordered text-nowrap text-md-nowrap mg-b-0'>
                  <thead>
                    <tr className='text-center'>
                      <th>ID</th>
                      <th>Question ID</th>
                      <th>Description</th>
                      <th>IS Correct</th>
                    </tr>
                  </thead>
                  <tbody>
                    {choice?.choices?.length
                      ? choice.choices.map(choice => (
                          <tr key={choice.id} className='text-center'>
                            <td>{choice.id}</td>
                            <td>{choice.questionId}</td>
                            <td>{choice.text}</td>
                            <td>
                              {' '}
                              <input type='checkbox' readOnly checked={choice.isCorrect} />
                            </td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default QuestionChoice
